module.exports = __webpack_public_path__ + "static/media/Calendar Single.b302dbb1.png";